import { render } from "./InputTextRequired.vue?vue&type=template&id=4fdb73e4"
import script from "./InputTextRequired.vue?vue&type=script&lang=js"
export * from "./InputTextRequired.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__